import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-personalloans-v2-item.component.scss';
var CalculatorPersonalloansV2Item = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorPersonalloansV2Item, _super);
    function CalculatorPersonalloansV2Item(element) {
        return _super.call(this, element) || this;
    }
    CalculatorPersonalloansV2Item.prototype.init = function () { };
    CalculatorPersonalloansV2Item.prototype.bindEvents = function () { };
    return CalculatorPersonalloansV2Item;
}(Base));
export { CalculatorPersonalloansV2Item };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculator-personalloans-v2-item/calculator-personalloans-v2-item.component.ts
// module id = 792
// module chunks = 0